import {timediff} from "../_resources/waffle-helpers.js";
import {createCard, makeCardSelectable} from "../_resources/ui-library.js";
import { checkSupaAccess } from "../_resources/supa-helpers.js";
import { accessControlDialogCreate } from "../_resources/accesscontrol-dialog.js";

const ServerStatusSectionView = function({ dom, onClickRefresh }) {
  const container = dom;

  const sectionHeader = container.append("div").class("admin-section-header")
    sectionHeader.append("h1").text("Data Servers");

  const actionsBox = sectionHeader.append("div").class("actionsbox").style("visibility", "hidden");
  actionsBox.append("button").class("button").text("⬇⬆ Refresh").on("click", onClickRefresh)

  const statusGrid = container.append("div").class("admin-grid");



  function render(data, onClickCard){
    actionsBox.style("visibility", "visible");
    
    const cards = statusGrid.selectAll("div.admin-card").data(data, d => d.id);
    cards.enter().append((d) => createCard({
      id: "card-" + d.id,
      title: d.slug,
      subtitle: `<a href="${d.url}status" target="_blank">${d.url}</a> · <a href="http://${d.ip_address}/status" target="_blank">IP</a>`,
      note: d.note,
      image: "./assets/images/waffle.png",
      badge: "waiting"
    }));
    cards.exit().remove();

    makeCardSelectable(statusGrid, (id) => {
      const selectedServer = data.find(d => "card-" + d.id === id);
      if (!selectedServer) return console.error("Can't select server", id );
      onClickCard(selectedServer);
    });
  }

  function updateCard(id, status, selectedServerId, selectedServerUrl, getToken, getUserId){
    const kind = status ? "ok" : "error";
      
    const view = container.selectAll("#card-" + id);
    view.select(".badge").style("display",kind?null:"none").class("badge "+kind).text(kind);
    if(kind!=="ok") return;
    view.classed("is-selected", () => id === selectedServerId);
    const extras = view.selectAll(".card-extras")
    extras.text("");
    extras.append(() => getAccessControlButton(id, selectedServerUrl, getToken, getUserId));
    
    extras.append("div")
      .text(`Small Waffle v${status.smallWaffleVersion}, DDFCSV Reader v${status.DDFCSVReaderVersion}, uptime ${timediff(status.liveSince, false, false)}`)
    
    extras.append(() => getMemoryBar(status.memory));
  }


  return {render, updateCard}

}


function getAccessControlButton(serverId, selectedServerUrl, getToken, getUserId) {
  const hasServerOwnerAccess = checkSupaAccess({user: getUserId(), scope: "server", resource: serverId, atLeast: "owner"});
  const button = d3.create("button")
    .class("button")
    .style("display", hasServerOwnerAccess ? null : "none")
    .text("Edit access")
    .on("click", async () => {
      await accessControlDialogCreate({ scope: "server", resource: serverId });
    })
  return button.node();
}

function getMemoryBar(
  {limit_MB, heapTotal_PCT, heapUsed_PCT} = {}, 
  {height = 30, textHeight = 27, barHeight = 3, dotSize = 7} = {}
) {
  const foreground = "var(--txt-1)";
  const background = "var(--line)";

  const div = d3.create("div")
    .class("memory-bar")
    .style("width", "100%")
    .style("height", height + "px")

  div.append("div")
    .style("left",0)
    .style("top", textHeight + "px")
    .style("width", "100%")
    .style("height", barHeight + "px")
    .style("background", background)

  div.append("div")
    .style("left",0)
    .style("top", textHeight + "px")
    .style("width",heapTotal_PCT + "%")
    .style("height", barHeight + "px")
    .style("background", foreground)

  div.append("div")
    .style("left", `calc(${heapUsed_PCT}% - ${Math.floor(dotSize / 2)}px)`)
    .style("top", (textHeight - Math.floor(dotSize / 2) + 1) + "px")
    .style("width", dotSize + "px")
    .style("height", dotSize + "px")
    .style("border", "1px solid " + foreground)
    .style("border-radius", "999px") //circle
    .style("background", background) 

  div.append("div")
    .style("left","0px")
    .style("top","0px")
    .text(`Memory used: ${heapUsed_PCT}%, allocated: ${heapTotal_PCT}% of ${limit_MB/1000} GB limit`)
  
  return div.node();
}


export default ServerStatusSectionView;






